import { Component, OnInit, Input } from "@angular/core";
import { ProductPlan } from "../plan-chooser.service";
import { SeoService } from "src/app/core";

@Component({
    selector: "app-plan-chooser-item",
    templateUrl: "./plan-chooser-item.component.html",
    styleUrls: ["./plan-chooser-item.component.scss"],
    standalone: false
})
export class PlanChooserItemComponent implements OnInit {
  @Input() plan: ProductPlan;

  signupLink: string;

  constructor(private seoService: SeoService) {}

  ngOnInit() {
    this.signupLink = `/signup/${this.seoService.normalizeForUrl(this.plan.title.toLowerCase())}`;
  }
}
